<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <Select :items="filteredTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" :disabled="localValue.id" />
      <InputZoom
        clearable
        required
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        v-model:complete-object="originWarehouseObject"
        :error="localErrors.idOriginWarehouse"
        database="warehouse"
        item-text="name"
        item-value="id"
        placeholder="Selecionar o depósito" />

      <InputZoom
        clearable
        required
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        :error="localErrors.idDestinationWarehouse || localErrors.sameWarehouse"
        database="warehouse"
        item-text="name"
        item-value="id"
        placeholder="Selecionar o depósito" />

      <InputDateTime v-model="localValue.date" label="Data" required :error="localErrors.date" placeholder="Selecione a data e hora" disabled />
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch, onMounted, computed } from 'vue'
import { useFormat } from '@/composables/useFormat'
import moment from 'moment'

const { formatDatetimeToTimezone } = useFormat()

const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const originWarehouseObject = ref(null)

const allowedTypesByWarehouse = {
  team: ['devolution', 'transfer', 'downward'],
  physic: ['outgoing', 'devolution', 'supplierDevolution', 'transfer'],
  vehicles: ['devolution', 'transfer', 'downward'],
}

const filteredTypes = computed(() => {
  if (!originWarehouseObject.value || !originWarehouseObject.value.type) {
    return allTypes
  }

  const warehouseType = originWarehouseObject.value.type
  const allowedValues = allowedTypesByWarehouse[warehouseType] || []

  return allTypes.filter((type) => allowedValues.includes(type.value))
})

// onMounted(() => {
//   localValue.date = moment().format()
// })

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

watch(originWarehouseObject, (newWarehouse) => {
  if (newWarehouse && newWarehouse.type && localValue.type) {
    const allowedValues = allowedTypesByWarehouse[newWarehouse.type] || []
    if (!allowedValues.includes(localValue.type)) {
      localValue.type = null
    }
  }
})
</script>
